var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          x: "8",
          y: "12",
          width: "24",
          height: "18",
          rx: "4",
          fill: "#7c3aed",
        },
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          x1: "20",
          y1: "12",
          x2: "20",
          y2: "6",
          stroke: "#7c3aed",
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "20", cy: "5", r: "2.5", fill: "#a78bfa" } }),
      _vm._v(" "),
      _c("circle", {
        attrs: { cx: "14.5", cy: "20", r: "2.5", fill: "#ede9fe" },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: { cx: "25.5", cy: "20", r: "2.5", fill: "#ede9fe" },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: { cx: "14.5", cy: "20", r: "1", fill: "#4c1d95" },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: { cx: "25.5", cy: "20", r: "1", fill: "#4c1d95" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "15",
          y: "25",
          width: "10",
          height: "2",
          rx: "1",
          fill: "#c4b5fd",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M4 8l1.2-2.4L7.6 4.4 5.2 3.2 4 0.8 2.8 3.2 0.4 4.4l2.4 1.2z",
          fill: "#a78bfa",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M35 10l0.9-1.8 1.8-0.9-1.8-0.9L35 4.6l-0.9 1.8-1.8 0.9 1.8 0.9z",
          fill: "#c4b5fd",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M36 28l0.7-1.4 1.4-0.7-1.4-0.7L36 23.8l-0.7 1.4-1.4 0.7 1.4 0.7z",
          fill: "#ddd6fe",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }